/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Center_RightInputs */



/**
* | output |
* | --- |
* | "Position Center Right" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Center_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_center_right = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Center_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Center_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner au centre droit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position Mitte rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione Centro Destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция: Центр справа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición Centro Derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置中心右侧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央右の位置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति केंद्र दाईं ओर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição Central Direita")
	return /** @type {LocalizedString} */ ("Position Center Right")
});